module.exports = __webpack_public_path__ + "static/mary-kay-about-51c2279492d1e8d055b93018440008ee.png";